import { render } from "./DynamicEntityList.vue?vue&type=template&id=89df5fac&scoped=true&ts=true"
import script from "./DynamicEntityList.vue?vue&type=script&lang=ts"
export * from "./DynamicEntityList.vue?vue&type=script&lang=ts"

import "./DynamicEntityList.vue?vue&type=style&index=0&id=89df5fac&scoped=true&lang=css"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89df5fac"]])

export default __exports__